import * as React from "react";
import {useEffect, useState} from "react";
import TextFieldValidator from "../../../components/form/TextFieldValidator";
import {useResources} from "../../../stores/ResourceProvider";
import Schedule from "../../../model/Schedule";
import ScheduleSelector from "../../../components/controls/ScheduleSelector";
import ModelEditDialog from "../../../components/model/ModelEditDialog";
import {SnapshotEditDetail} from "./BudgetSnapshotDialog";
import {moneyToNumberFormat, numberToMoneyFormat} from "../../../stores/StoreUtilities";

const SnapshotDetailEditDialog = ({
  open,
  detail,
  onClose,
  onSave
}: {
  open?: boolean
  detail: SnapshotEditDetail
  onClose?(): void
  onSave?(detail: SnapshotEditDetail): void
}) => {
  const [id, setId] = useState<string | undefined>()
  const [typename, setTypename] = useState<string | undefined>()
  const [amount, setAmount] = useState<string | undefined>()
  const [schedule, setSchedule] = useState<Schedule | undefined>()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const { notify } = useResources()

  useEffect(() => {
    setId(detail.id)
    setTypename(detail.typename)
    // setBalance(numberToMoneyFormat(detail.balance, 0))
    setAmount(detail.amount)
    setSchedule(detail.schedule ?? new Schedule(detail.schedule))
    setIsOpen(open === true)
  }, [detail, open])

  const handleClose = async (event: any) => {
    if (onClose) {
      onClose()
    }
  }

  const handleSave = async (event: any) => {
    try {
      const update: SnapshotEditDetail = {
        id: id!,
        typename: typename!,
        balance: detail.balance,
        amount: amount === detail.amount ? detail.amount : numberToMoneyFormat(moneyToNumberFormat(amount, 0), 0),
        originalAmount: detail.originalAmount,
        schedule: schedule,
        item: detail.item
      }

      if (onSave && update) {
        onSave(update)
      } else if (onClose) {
        onClose()
      }
    } catch (err: any) {
      notify.show('error', err.message)
    }
  }

  if (!id || !isOpen) {
    return null
  }

  return (
    <ModelEditDialog title={`Edit Snapshot Detail`} open={isOpen}
                     onCancel={handleClose}
                     onSave={handleSave}
    >
      <TextFieldValidator
        type="string"
        validators={{ isMoney: true }}
        name="amount"
        variant="standard"
        margin="dense"
        fullWidth
        label="Amount"
        value={amount}
        onChange={(event: any) => setAmount(event.target.value)}
      />
      <ScheduleSelector
        value={schedule!}
        onChange={(value: Schedule) => setSchedule(value)}
      />
    </ModelEditDialog>
  )
}

export default SnapshotDetailEditDialog